import Glider from 'glider-js';
import domready from 'domready';

const defaultSliderOptions = {
  slidesToShow: 1,
  slidesToScroll: 1,
  draggable: true,
  scrollLock: true,
  resizeLock: true,
  rewind: true,
};

const logoSliderOption = {
  slidesToShow: 2,
  slidesToScroll: 1,
  draggable: true,
  scrollLock: true,
  resizeLock: true,
  rewind: true,
  responsive: [
    {
      breakpoint: 640,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 840,
      settings: { slidesToShow: 4 },
    },
    {
      breakpoint: 1028,
      settings: { slidesToShow: 5 },
    },
  ],
};

/**
 * @param {HTMLElement} element
 * @param {boolean} isLogoSlider
 */
function createSlider(element, isLogoSlider) {
  const slider = new Glider(element, isLogoSlider ? logoSliderOption : defaultSliderOptions);

  if (element.dataset.autoslide === '1') {
    const autoplayDelay = 1000 * element.dataset.slideinterval;
    let timeout = -1;
    let hovering = false;

    // eslint-disable-next-line no-inner-declarations
    function startTimeout() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        if (!hovering) {
          slider.scrollItem((slider.slide + slider.opt.slidesToShow) % slider.slides.length);
        }
      }, autoplayDelay);
    }

    let animID = 0;
    const isAnimating = () => slider.animate_id !== animID;
    element.addEventListener('glider-animated', () => {
      animID = slider.animate_id;
      if (!hovering) startTimeout();
    });

    element.addEventListener('mouseover', () => {
      hovering = true;
      clearTimeout(timeout);
    });

    element.addEventListener('mouseout', () => {
      hovering = false;
      if (!isAnimating()) startTimeout();
    });

    startTimeout();
  }

  slider.setOption({
    draggable: true,
    arrows: {
      prev: element.parentElement.querySelector('.slider__control--prev'),
      next: element.parentElement.querySelector('.slider__control--next'),
    },
    dots: element.parentElement.querySelector('.slider__pagination'),
  }, isLogoSlider);
  slider.refresh(true);
}

domready(() => {
  const sliderFrames = document.querySelectorAll('div.slider .slider__frame');
  Array.prototype.forEach.call(sliderFrames, (element) => {
    console.warn('Legacy Slider: Use toujou-slider instead', element)
    const isLogoSlider = element.parentElement.classList.contains('slider--logo');
    createSlider(element, isLogoSlider);
  });
});
